<template>
  <b-container>
    <b-row class="d-flex justify-content-center">
      <h1>Resource Detail</h1>
      <educational-item-detail :uuid="uuid"></educational-item-detail>
    </b-row>
  </b-container>
</template>

<script>
  import EducationalItemDetail from "@/components/educational_resources/EducationalItemDetail";
  export default  {
    name: 'ResourceDetail',
    components: {
      EducationalItemDetail
    },
    mounted () {

    },
    data () {
      return {
        uuid: this.$route.params.uuid
      }
    }
}

</script>
